
define('text!presentation/common/dataGrid/views/dataGrid.html',[],function () { return '<div class="data-grid" data-bind="contentPaneInfiniteScroll: { buffer: infiniteScrollBuffer }">\n    <div data-bind="foreach: dataSet">\n        <div data-part="dataGridBodyRow"/>\n    </div>\n</div>';});

